import {BaseAttribute, BaseAttributeOptions} from './BaseAttribute';

/** Options for boolean attributes (same as {@link BaseAttributeOptions} for now). */
export type BooleanAttributeOptions = BaseAttributeOptions;

export class BooleanAttribute extends BaseAttribute {
  constructor(options: BooleanAttributeOptions = {}) {
    super(options);
  }

  // Input type that is used if attribute is used in edit mode
  get inputType(): string {
    return 'boolean';
  }

  getInitialValue(): unknown {
    return this.creationValue ? Boolean(this.creationValue) : false;
  }
}
